const axios = require('axios');

(() => {
  const selectBarbecueOption = '.select-customer-barbecue-option'

  const init = () => {
    if (location.href.indexOf('customer/barbecue/barbecue_option') < 1 ) {
      return
    }
    $('body')
      .on('change', selectBarbecueOption, changePrice)
  }
  const changePrice = () => {
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/barbecue/barbecue_option/change',
      method: 'POST',
      data: $('form').serialize(),
      withCredentials: true,
      headers: {'X-CSRF-Token': token}
    })
    .then(response => {
      $('.plan-block-right').html(response['data'])
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }
  $(init);
})();

